import React from 'react';
export var Info = function (_a) {
    var color = _a.color;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "0.96em", viewBox: "0 0 25 24", color: color, fill: "none" },
        React.createElement("path", { d: "M2.106 16.305a11.25 11.25 0 1 1 20.787-8.61 11.25 11.25 0 0 1-20.787 8.61Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }),
        React.createElement("path", { d: "M10.5 10.05h1.946v7.785M10.5 17.834h3.892", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }),
        React.createElement("circle", { cx: 12.258, cy: 5.813, r: 1.313, fill: "currentColor" })));
};
